import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "prototype_room" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("新样板间")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_6 = { class: "createOrUpdatePrototypeRoom" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "el-upload-list__item-actions" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "dialog-footer" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_16 = { class: "prototype_room" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_18 = { class: "dialog-footer" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("取消")

import { defineComponent } from 'vue';
import store from '@/store/index';
import { useStore } from '@/store/index';
import { ref, reactive } from 'vue';
import tool from '@/utils/tool';
import router from '@/router/index';
import { ElButton, ElMessage, ElMessageBox } from 'element-plus';
import type { ElForm, Action } from 'element-plus';
import { Plus, ZoomIn, Download, Delete } from '@element-plus/icons-vue';
import type { UploadFile } from 'element-plus/es/components/upload/src/upload.type';

interface PrototypeRoomVo {
  id: string;
  name: string;
  houseNatureId: string;
  decorateTypeId: string;
  decorateStyleId: string;
  projectId: string;
  projectName: string;
  remark: string;
  vrUrl: string;
  imageUriList: string[];
}

interface ProjectVo {
  id: string;
  name: string;
  area: string;
}

interface PrototypeRoomImageVo {
  uid: number;
  name: string;
  url: string;
}

type FormInstance = InstanceType<typeof ElForm>;

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const ustore = useStore();
const loading = ref(true);

const createOrEditFormData: PrototypeRoomVo = {
  id: '',
  name: '',
  houseNatureId: '',
  decorateTypeId: '',
  decorateStyleId: '',
  projectId: '',
  projectName: '点击选择',
  remark: '',
  vrUrl: '',
  imageUriList: [],
};

const imgList: PrototypeRoomImageVo[] = [];

const bindData = reactive({
  houseNatureList: [],
  decorateTypeList: [],
  decorateStyleList: [],
  projectPageParams: {
    curPage: 1,
    pageSize: 10,
    filtrate: {
      keyword: '',
    },
  },
  projectPageResult: {
    status: 2000,
    msg: '成功',
    result: [],
    totalCount: 0,
  },
  prototypeRoomPageParams: {
    curPage: 1,
    pageSize: 10,
    filtrate: {
      keyword: '',
    },
  },
  prototypeRoomPageResult: {
    status: 2000,
    msg: '成功',
    result: [],
    totalCount: 0,
  },
  createOrEditFormData: createOrEditFormData,
  imageList: imgList,
  createOrEditFormTitle: '',
});

const handleSizeChangeEvent = (value: any) => {
  bindData.prototypeRoomPageParams.pageSize = value;
  bindData.prototypeRoomPageParams.curPage = 1;
  searchEvent();
};

const handleCurrentChangeEvent = (value: any) => {
  bindData.prototypeRoomPageParams.curPage = value;
  searchEvent();
};

const searchEvent = () => {
  loading.value = true;
  store
    .dispatch(
      'prototypeRoomListModule/pagePrototypeRoomList',
      bindData.prototypeRoomPageParams
    )
    .then(
      (data) => {
        //成功
        bindData.prototypeRoomPageResult = data;
        loading.value = false;
      },
      (error) => {
        console.log(error.msg);
      }
    );
};

searchEvent();

//新增或更新
const createOrEditDialogVisible = ref(false);

const createOrEditHandleCloseEvent = (done: () => void) => {
  done();
};

const projectHandleSizeChangeEvent = (value: any) => {
  bindData.projectPageParams.pageSize = value;
  bindData.projectPageParams.curPage = 1;
  projectSearchEvent();
};

const projectHandleCurrentChangeEvent = (value: any) => {
  bindData.projectPageParams.curPage = value;
  projectSearchEvent();
};

const projectSearchEvent = () => {
  loading.value = true;
  store
    .dispatch(
      'prototypeRoomListModule/pageProjectList',
      bindData.projectPageParams
    )
    .then(
      (data) => {
        //成功
        for (var index in data.result) {
          const obj = data.result[index];
          obj.shortAddr = obj.province + '-' + obj.city + '-' + obj.area;
        }
        bindData.projectPageResult = data;
        loading.value = false;
      },
      (error) => {
        console.log(error.msg);
      }
    );
};

//项目选择
const selectProjectDialogVisible = ref(false);

const projectListHandleCloseEvent = (done: () => void) => {
  done();
};

const projectCurrentRow = ref();

const projectHandleCurrentSelectEvent = (val: ProjectVo | undefined) => {
  projectCurrentRow.value = val;
};

const chooseProjectOkEvent = () => {
  selectProjectDialogVisible.value = false;
  bindData.createOrEditFormData.projectId = projectCurrentRow.value.id;
  bindData.createOrEditFormData.projectName = projectCurrentRow.value.name;
};

const loadSelect = () => {
  store.dispatch('prototypeRoomListModule/listHouseNature', {}).then(
    (data) => {
      //成功
      bindData.houseNatureList = data.result;
    },
    (error) => {
      console.log(error.msg);
    }
  );
  store.dispatch('prototypeRoomListModule/listDecorateType', {}).then(
    (data) => {
      //成功
      bindData.decorateTypeList = data.result;
    },
    (error) => {
      console.log(error.msg);
    }
  );
  store.dispatch('prototypeRoomListModule/listDecorateStyle', {}).then(
    (data) => {
      //成功
      bindData.decorateStyleList = data.result;
    },
    (error) => {
      console.log(error.msg);
    }
  );
};

const loadImageList = (prototypeRoomId: string) => {
  store
    .dispatch('prototypeRoomListModule/listPrototypeRoomImage', {
      prototypeRoomId: prototypeRoomId,
    })
    .then(
      (data) => {
        //成功
        bindData.imageList = [];
        var index = 1;
        const backImageList: PrototypeRoomImageVo[] = [];
        for (var image of data.result) {
          const imageFile: PrototypeRoomImageVo = {
            uid: index,
            name: image.id,
            url: image.imgUrl,
          };

          backImageList.push(imageFile);
          index++;
        }
        bindData.imageList = backImageList;
        console.log(bindData.imageList);
      },
      (error) => {
        console.log(error.msg);
      }
    );
};

const showProjectSelectListEvent = () => {
  selectProjectDialogVisible.value = true;
  projectSearchEvent();
};

const showCreateFormEvent = () => {
  loadSelect();
  bindData.createOrEditFormData = {
    id: '',
    name: '',
    houseNatureId: '',
    decorateTypeId: '',
    decorateStyleId: '',
    projectId: '',
    projectName: '',
    remark: '',
    vrUrl: '',
    imageUriList: [],
  };
  bindData.imageList = [];
  bindData.createOrEditFormTitle = '新建样板间';
  createOrEditDialogVisible.value = true;
};

const showUpdateFormEvent = (index: number, row: PrototypeRoomVo) => {
  loadSelect();
  bindData.createOrEditFormData = row;
  bindData.createOrEditFormData.imageUriList = [];
  bindData.imageList = [];
  bindData.createOrEditFormTitle = '编辑样板间';
  loadImageList(row.id);
  createOrEditDialogVisible.value = true;
};

const deleteEvent = (index: number, row: PrototypeRoomVo) => {
  ElMessageBox.confirm(`您确定要删除 ${row.name} 吗?`)
    .then(() => {
      const params = {
        prototypeRoomId: row.id,
      };
      store
        .dispatch('prototypeRoomListModule/deletePrototypeRoom', params)
        .then(
          (data) => {
            //成功
            ElMessage.success('删除成功.');
          },
          (error) => {
            ElMessageBox.alert(error.msg, '系统消息', {
              confirmButtonText: '关闭',
              callback: (action: Action) => {},
            });
          }
        );
    })
    .catch(() => {
      // catch error
    });
};

const prototypeRoomFormRef = ref<FormInstance>();

const validateName = (rule: any, value: any, callback: any) => {
  if (value === '') {
    callback(new Error('请输入名称'));
  } else {
    callback();
  }
};

const prototypeRoomRules = reactive({
  name: [{ required: true, validator: validateName, trigger: 'blur' }],
});

const submitPrototypeRoomForm = (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  formEl.validate((valid) => {
    if (valid) {
      store
        .dispatch(
          'prototypeRoomListModule/saveOrUpdatePrototypeRoom',
          bindData.createOrEditFormData
        )
        .then(
          (data) => {
            //成功
            createOrEditDialogVisible.value = false;
            ElMessage.success('保存成功');
            searchEvent();
          },
          (error) => {
            ElMessageBox.alert(error.msg, '系统消息', {
              confirmButtonText: '关闭',
              callback: (action: Action) => {},
            });
          }
        );
    } else {
      console.log('error submit!');
      return false;
    }
  });
};

const imageListDialogImageUrl = ref('');
const imageListDialogVisible = ref(false);
const imageListDisabled = ref(false);

const imageListHandleRemoveEvent = (file: UploadFile) => {
  ElMessageBox.confirm(`您确定要删除吗?`)
    .then(() => {
      const imageList: PrototypeRoomImageVo[] = [];
      for (var i = 0; i < bindData.imageList.length; i++) {
        if (file.uid != bindData.imageList[i].uid) {
          imageList.push(bindData.imageList[i]);
        }
      }
      bindData.imageList = imageList;
      const params = {
        prototypeRoomImageId: file.name,
      };
      store
        .dispatch('prototypeRoomListModule/deletePrototypeRoomImage', params)
        .then(
          (data) => {
            //成功
            ElMessage.success('删除图片成功.');
          },
          (error) => {
            ElMessageBox.alert(error.msg, '系统消息', {
              confirmButtonText: '关闭',
              callback: (action: Action) => {},
            });
          }
        );
    })
    .catch(() => {
      // catch error
    });
};
const imageListHandlePreviewEvent = (file: UploadFile) => {
  imageListDialogImageUrl.value = file.url!;
  imageListDialogVisible.value = true;
};
const imageListHandleDownloadEvent = (file: UploadFile) => {
  console.log(file);
  window.open(file.url, 'Download');
};

const uploadSuccessEvent = (
  response: any,
  file: UploadFile,
  fileList: UploadFile[]
) => {
  const image: PrototypeRoomImageVo = {
    uid: file.uid,
    name: file.name,
    url: '',
  };
  if (file.url != undefined) {
    image.url = file.url;
  }
  bindData.imageList.push(image);
  bindData.createOrEditFormData.imageUriList.push(response.result);
};

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, { class: "prototype_room-search" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, { class: "prototype_room-search-lt" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { class: "prototype_room-search-lt-text" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  placeholder: "",
                  size: "large",
                  modelValue: _unref(bindData).prototypeRoomPageParams.filtrate.keyword,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(bindData).prototypeRoomPageParams.filtrate.keyword) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { class: "prototype_room-search-lt-btn" }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElButton), {
                  type: "primary",
                  size: "large",
                  onClick: searchEvent
                }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_unref(ElButton), {
          class: "prototype_room-search-rt",
          type: "primary",
          size: "large",
          onClick: showCreateFormEvent
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      data: _unref(bindData).prototypeRoomPageResult.result,
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "name",
          label: "名称",
          width: "120"
        }),
        _createVNode(_component_el_table_column, {
          prop: "projectName",
          label: "所属项目",
          width: "120"
        }),
        _createVNode(_component_el_table_column, {
          prop: "houseNatureName",
          label: "房屋性质",
          width: "120"
        }),
        _createVNode(_component_el_table_column, {
          prop: "decorateTypeName",
          label: "装修类型",
          width: "120"
        }),
        _createVNode(_component_el_table_column, {
          prop: "decorateStyleName",
          label: "风格",
          width: "120"
        }),
        _createVNode(_component_el_table_column, {
          fixed: "right",
          label: "操作",
          width: "200"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_unref(ElButton), {
              type: "text",
              size: "small",
              onClick: ($event: any) => (showUpdateFormEvent(scope.$index, scope.row))
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_unref(ElButton), {
              type: "text",
              size: "small",
              onClick: ($event: any) => (deleteEvent(scope.$index, scope.row))
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, loading.value]
    ]),
    _createVNode(_component_el_container, { class: "prototype_room-page_toolbar" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_pagination, {
          currentPage: _unref(bindData).prototypeRoomPageParams.curPage,
          "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => ((_unref(bindData).prototypeRoomPageParams.curPage) = $event)),
          "page-size": _unref(bindData).prototypeRoomPageParams.pageSize,
          "onUpdate:page-size": _cache[2] || (_cache[2] = ($event: any) => ((_unref(bindData).prototypeRoomPageParams.pageSize) = $event)),
          "page-sizes": [10, 20, 50, 100],
          layout: "total, sizes, prev, pager, next, jumper",
          total: _unref(bindData).prototypeRoomPageResult.totalCount,
          "onUpdate:total": _cache[3] || (_cache[3] = ($event: any) => ((_unref(bindData).prototypeRoomPageResult.totalCount) = $event)),
          onSizeChange: handleSizeChangeEvent,
          onCurrentChange: handleCurrentChangeEvent
        }, null, 8, ["currentPage", "page-size", "total"])
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      modelValue: createOrEditDialogVisible.value,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((createOrEditDialogVisible).value = $event)),
      title: _unref(bindData).createOrEditFormTitle,
      "onUpdate:title": _cache[15] || (_cache[15] = ($event: any) => ((_unref(bindData).createOrEditFormTitle) = $event)),
      width: "60%",
      "before-close": createOrEditHandleCloseEvent
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_13, [
          _createVNode(_unref(ElButton), {
            type: "primary",
            onClick: _cache[12] || (_cache[12] = ($event: any) => (submitPrototypeRoomForm(prototypeRoomFormRef.value)))
          }, {
            default: _withCtx(() => [
              _hoisted_14
            ]),
            _: 1
          }),
          _createVNode(_unref(ElButton), {
            onClick: _cache[13] || (_cache[13] = ($event: any) => (createOrEditDialogVisible.value = false))
          }, {
            default: _withCtx(() => [
              _hoisted_15
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_scrollbar, { height: "450px" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_el_form, {
                ref_key: "prototypeRoomFormRef",
                ref: prototypeRoomFormRef,
                model: _unref(bindData).createOrEditFormData,
                "status-icon": "",
                rules: _unref(prototypeRoomRules),
                "label-width": "120px",
                class: "prototypeRoomForm"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "名称",
                    prop: "name"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _unref(bindData).createOrEditFormData.name,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(bindData).createOrEditFormData.name) = $event)),
                        type: "text",
                        autocomplete: "off"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "房屋性质",
                    prop: "houseNatureId"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _unref(bindData).createOrEditFormData.houseNatureId,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(bindData).createOrEditFormData.houseNatureId) = $event)),
                        size: "large"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).houseNatureList, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.id,
                              label: item.name,
                              value: item.id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "装修类型",
                    prop: "decorateTypeId"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _unref(bindData).createOrEditFormData.decorateTypeId,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(bindData).createOrEditFormData.decorateTypeId) = $event)),
                        size: "large"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).decorateTypeList, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.id,
                              label: item.name,
                              value: item.id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "风格",
                    prop: "decorateStyleId"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _unref(bindData).createOrEditFormData.decorateStyleId,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(bindData).createOrEditFormData.decorateStyleId) = $event)),
                        size: "large"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).decorateStyleList, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.id,
                              label: item.name,
                              value: item.id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "所属项目",
                    prop: "projectId"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _unref(bindData).createOrEditFormData.projectName,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(bindData).createOrEditFormData.projectName) = $event)),
                        type: "text",
                        autocomplete: "off",
                        placeholder: "请点击选择",
                        onClick: showProjectSelectListEvent
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "介绍",
                    prop: "remark"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _unref(bindData).createOrEditFormData.remark,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(bindData).createOrEditFormData.remark) = $event)),
                        type: "textarea",
                        autosize: { minRows: 4, maxRows: 8 },
                        autocomplete: "off"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "全景VR链接",
                    prop: "vrUrl"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _unref(bindData).createOrEditFormData.vrUrl,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(bindData).createOrEditFormData.vrUrl) = $event)),
                        type: "text",
                        autocomplete: "off"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "图册" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_upload, {
                        "file-list": _unref(bindData).imageList,
                        action: _unref(tool).url('/personalCenter/uploadPrototypeRoomImage'),
                        "list-type": "picture-card",
                        multiple: false,
                        "with-credentials": true,
                        "on-success": uploadSuccessEvent
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Plus))
                            ]),
                            _: 1
                          })
                        ]),
                        file: _withCtx(({ file }) => [
                          _createElementVNode("div", null, [
                            _createElementVNode("img", {
                              class: "el-upload-list__item-thumbnail",
                              src: file.url,
                              alt: ""
                            }, null, 8, _hoisted_7),
                            _createElementVNode("span", _hoisted_8, [
                              _createElementVNode("span", {
                                class: "el-upload-list__item-preview",
                                onClick: ($event: any) => (imageListHandlePreviewEvent(file))
                              }, [
                                _createVNode(_component_el_icon, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(ZoomIn))
                                  ]),
                                  _: 1
                                })
                              ], 8, _hoisted_9),
                              (!imageListDisabled.value)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: "el-upload-list__item-delete",
                                    onClick: ($event: any) => (imageListHandleDownloadEvent(file))
                                  }, [
                                    _createVNode(_component_el_icon, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(Download))
                                      ]),
                                      _: 1
                                    })
                                  ], 8, _hoisted_10))
                                : _createCommentVNode("", true),
                              (!imageListDisabled.value)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 1,
                                    class: "el-upload-list__item-delete",
                                    onClick: ($event: any) => (imageListHandleRemoveEvent(file))
                                  }, [
                                    _createVNode(_component_el_icon, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(Delete))
                                      ]),
                                      _: 1
                                    })
                                  ], 8, _hoisted_11))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        _: 1
                      }, 8, ["file-list", "action"]),
                      _createVNode(_component_el_dialog, {
                        modelValue: imageListDialogVisible.value,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((imageListDialogVisible).value = $event))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("img", {
                            width: "100%",
                            src: imageListDialogImageUrl.value,
                            alt: ""
                          }, null, 8, _hoisted_12)
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model", "rules"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      modelValue: selectProjectDialogVisible.value,
      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((selectProjectDialogVisible).value = $event)),
      title: "请选择所属项目",
      width: "40%",
      "before-close": projectListHandleCloseEvent
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_18, [
          _createVNode(_unref(ElButton), {
            type: "primary",
            onClick: _cache[20] || (_cache[20] = ($event: any) => (chooseProjectOkEvent()))
          }, {
            default: _withCtx(() => [
              _hoisted_19
            ]),
            _: 1
          }),
          _createVNode(_unref(ElButton), {
            onClick: _cache[21] || (_cache[21] = ($event: any) => (selectProjectDialogVisible.value = false))
          }, {
            default: _withCtx(() => [
              _hoisted_20
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_el_container, { class: "prototype_room-search" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form, { class: "prototype_room-search-lt" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { class: "prototype_room-search-lt-text" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          placeholder: "",
                          size: "large",
                          modelValue: _unref(bindData).projectPageParams.filtrate.keyword,
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(bindData).projectPageParams.filtrate.keyword) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, { class: "prototype_room-search-lt-btn" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(ElButton), {
                          type: "primary",
                          size: "large",
                          onClick: projectSearchEvent
                        }, {
                          default: _withCtx(() => [
                            _hoisted_17
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              "highlight-current-row": "",
              data: _unref(bindData).projectPageResult.result,
              style: {"width":"100%"},
              onCurrentChange: projectHandleCurrentSelectEvent
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  type: "index",
                  width: "50"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "name",
                  label: "项目名称",
                  width: "250"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "shortAddr",
                  label: "项目地区",
                  width: "250"
                })
              ]),
              _: 1
            }, 8, ["data"])), [
              [_directive_loading, loading.value]
            ]),
            _createVNode(_component_el_container, { class: "prototype_room-page_toolbar" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_pagination, {
                  currentPage: _unref(bindData).projectPageParams.curPage,
                  "onUpdate:currentPage": _cache[17] || (_cache[17] = ($event: any) => ((_unref(bindData).projectPageParams.curPage) = $event)),
                  "page-size": _unref(bindData).projectPageParams.pageSize,
                  "onUpdate:page-size": _cache[18] || (_cache[18] = ($event: any) => ((_unref(bindData).projectPageParams.pageSize) = $event)),
                  "page-sizes": [10, 20, 50, 100],
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _unref(bindData).projectPageResult.totalCount,
                  "onUpdate:total": _cache[19] || (_cache[19] = ($event: any) => ((_unref(bindData).projectPageResult.totalCount) = $event)),
                  onSizeChange: projectHandleSizeChangeEvent,
                  onCurrentChange: projectHandleCurrentChangeEvent
                }, null, 8, ["currentPage", "page-size", "total"])
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})